import { FormikSwitchField } from 'lib/components/formik/FormikSwitchField';
import React from 'react';
import {
  FormProps,
  RowWrapper,
  Section,
  SectionTitle,
} from '../../../components/AdminFormComponents';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'react-covideo-common';
import { Flex } from 'lib/components/styles/layout';

export const LandingPageBuilderSection = (props: FormProps) => {
  const { t } = useTranslation();
  const { setFieldValue, values } = props;
  const sectionTitle = t('New Landing Page Flow');
  const switchLabel = t('Enable New Landing Page Flow');

  return (
    <Section>
      <SectionTitle>{sectionTitle}</SectionTitle>
      <RowWrapper>
        <Tooltip
          position='right'
          popup={
            <Flex width='300px'>
              {t(
                'This toggle determines whether customers use legacy PHP landing pages or the new landing pages built with the Landing Page Builder.'
              )}
            </Flex>
          }
        >
          <FormikSwitchField
            extendStyles={{ wrapper: { margin: '0 0 16px 0' } }}
            name='isUsingLandingPageDesign'
            label={switchLabel}
            onChange={() => {
              setFieldValue(
                'isUsingLandingPageDesign',
                !values.isUsingLandingPageDesign
              );
            }}
          />
        </Tooltip>
      </RowWrapper>
    </Section>
  );
};
